import { useEffect } from "react";
import { useLocation, useParams } from "react-router";

function LangSwitcher(props) {
	const { lang } = useParams();
	const location = useLocation();

	useEffect(() => {
		if (lang != props.currentLang && props.onLangChange) {
			props.onLangChange(lang);
		}
	}, [lang]);

	useEffect(() => {
		props.onLangChange(lang);
	}, []);

	return <></>
}

export default LangSwitcher;